"use client";

import { api } from "@convex/_generated/api";
import { useQuery } from "convex/react";
import Link from "next/link";
import { TierListCard } from "@/app/tier-lists/tier-list-card";
import { Loader } from "@/components/loader";
import type { UserProfile } from "../utils";

interface TierListsSectionProps {
  profile: UserProfile;
}

export function TierListsSection({ profile }: TierListsSectionProps) {
  const tierListsQuery = useQuery(api.users.queries.getUserTierLists, {
    userId: profile._id,
    paginationOpts: { numItems: 6, cursor: null },
  });

  if (tierListsQuery === undefined) {
    return (
      <div className="flex justify-center py-12">
        <Loader />
      </div>
    );
  }

  const tierLists = tierListsQuery.page;

  if (tierLists.length === 0) {
    return (
      <div className="py-12 text-center">
        <h3 className="mb-2 font-semibold text-xl">No tier lists yet</h3>
        <p className="text-muted-foreground">
          {profile.username || "This user"} hasn't created any tier lists yet.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {profile.stats.totalTierLists > 6 && (
        <div className="flex justify-end">
          <Link
            className="font-mono text-[#46C8E0] text-xs tracking-wider hover:text-[#7bd9ea]"
            href={`/tier-lists?user=${profile.username || profile._id}`}
          >
            VIEW ALL →
          </Link>
        </div>
      )}

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {tierLists.map((tierList) => (
          <TierListCard key={tierList._id} tierList={tierList} />
        ))}
      </div>
    </div>
  );
}
